import { useTranslation } from 'react-i18next';

export default function PledgeBanner() {
  const { t } = useTranslation('home');

  return (
    <div className="px-3 mt-5 mb-6">
      <div className="relative bg-gradient-to-r from-brown-100 via-gold-50 to-brown-100 rounded-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4">
          {/* 左侧：金安承诺 */}
          <div className="flex items-center gap-3">
            {/* 徽章 */}
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-1 text-gold-600">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-award-line text-xs"></i>
                </span>
              </div>
              <div className="text-center mt-1">
                <p className="text-brown-900 text-sm font-bold leading-tight">
                  {t('jinanPromise')}
                </p>
                <p className="text-gold-600 text-[10px] tracking-wider mt-0.5">
                  COMMITMENT
                </p>
              </div>
            </div>
          </div>

          {/* 中间：标语 */}
          <div className="flex-1 text-center px-2">
            <p className="text-brown-800 text-sm font-semibold tracking-wider">
              {t('promiseValues')}
            </p>
            <p className="text-brown-500 text-xs mt-1">
              {t('promiseSubtitle')}
            </p>
          </div>

          {/* 右侧：建筑图片 */}
          <div className="w-24 h-16 rounded-lg overflow-hidden flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Classical%20European%20bank%20building%20facade%20with%20grand%20columns%2C%20warm%20golden%20hour%20lighting%2C%20luxury%20financial%20institution%20architecture%2C%20cream%20and%20gold%20tones%2C%20prestigious%20elegant%20atmosphere%2C%20editorial%20photography&width=800&height=300&seq=pledge-bg-2026&orientation=landscape"
              alt="building"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}